import styled from "styled-components";

import heroBgImg from './../../assets/images/static/heroBg.png';
import heroBgMob from './../../assets/images/static/heroBgMob.png';
import computerMob from './../../assets/images/static/computerMob.png';

export const HeroSection = styled.section`
  background: url(${heroBgImg}) no-repeat center;
  background-size: cover;
  display: flex;
  min-height: 1060px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: 880px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    min-height: 780px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 100vh;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 540px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    background: url(${heroBgMob}) no-repeat center top;
    background-size: cover;
    min-height: 970px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    min-height: 840px;
  }
`;

export const StyledContentSection = styled.div`
  flex: 1;
  z-index: 2;
`;

export const ContentDiv = styled.div`
  margin-left: 230px;
  margin-top: 350px;
  width: 565px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-left: 200px;
    margin-top: 310px;
    width: 520px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-left: 175px;
    margin-top: 270px;
    width: 460px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-left: 140px;
    margin-top: 240px;
    width: 400px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-left: 16%;
    margin-top: 200px;
    width: 340px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin: 144px auto 80px;
    text-align: center;
    width: 300px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin: 112px auto 60px;
  }
`;

export const MainHeading = styled.h1`
  margin-bottom: 24px;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-bottom: 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-bottom: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-bottom: 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-bottom: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-bottom: 14px;
  }
`;

export const SubTitle = styled.div`
  color: ${({theme}) => theme.colors.secondary};
  line-height: ${({theme}) => theme.lineHeight.primaryHeight};
  margin-bottom: 44px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    line-height: ${({theme}) => theme.lineHeight.hdPrimaryHeight};
    margin-bottom: 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    margin-bottom: 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    line-height: ${({theme}) => theme.lineHeight.smallHeight};
    margin-bottom: 28px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    font-family: 'RubikBold';
    margin-bottom: 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    line-height: ${({theme}) => theme.lineHeight.mobHeight};
    margin-bottom: 34px;
  }
`;

export const SignUpButton = styled.button`
  background-color: ${({theme}) => theme.colors.secondary};
  border-radius: ${({theme}) => theme.radius.round};
  border: 2px solid ${({theme}) => theme.colors.secondary};
  color: ${({theme}) => theme.colors.basic};
  font-size: ${({theme}) => theme.fonts.defaultSize};
  padding: 18px 72px;
  &:hover {
    background-color: ${({theme}) => theme.colors.basic};
    color: ${({theme}) => theme.colors.secondary};
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    border-radius: ${({theme}) => theme.radius.hdRound};
    font-size: ${({theme}) => theme.fonts.smallSize};
    padding: 16px 64px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    border-radius: ${({theme}) => theme.radius.medium};
    font-size: ${({theme}) => theme.fonts.smallerSize};
    padding: 12px 52px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    font-size: ${({theme}) => theme.fonts.smallestSize};
    padding: 10px 52px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    border-radius: ${({theme}) => theme.radius.normal};
    padding: 8px 46px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    border-radius: ${({theme}) => theme.radius.medium};
    font-size: ${({theme}) => theme.fonts.defaultSize};
    padding: 16px;
    width: 310px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding: 20px;
  }
`;

export const StyledImgDiv = styled.div`
  background: url(${computerMob}) no-repeat center top;
  background-size: 360px;
  min-height: 100%;
`;

export const StyledImageSection = styled.div`
  background-color: ${({theme}) => theme.colors.alternate};
  position: relative;
  width: 600px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 500px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 420px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 372px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 300px;
  }
`;

export const ImageDiv = styled.div`
  position: absolute;
  right: -20px;
  top: 173px;
  width: 1280px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    right: -30px;
    top: 125px;
    width: 1080px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 960px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    top: 100px;
    width: 820px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    top: 80px;
    width: 680px;
  }
`;

export const Img = styled.img`
  width: 100%;
`;

export const ImgIllustration = styled.img`
  bottom: 440px;
  position: absolute;
  right: 240px;
  width: 120px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    bottom: 364px;
    right: 206px;
    width: 100px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    bottom: 330px;
    right: 180px;
    width: 90px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    bottom: 285px;
    right: 156px;
    width: 74px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    bottom: 235px;
    right: 128px;
    width: 64px;
  }
`;
